export enum DtcLinkState {
  asigned = 'Assigned',
  removed = 'Removed',
  dtcMissing = 'DtcMissing',
  linkCanBeAdded = 'LinkCanBeAdded',
  linkCanBeRemoved = 'LinkCanBeRemoved',
}
